(() => {
  function init() {
    const heroH1 = document.querySelector(".section--new-hero-baner__title");
    if (heroH1) {
      heroH1.style.minHeight = heroH1.clientHeight + "px";
    }
    const typed = new Typed("#hero-typed", {
      strings: [
        "Busy Lives.",
        "Athletes.",
        "Parents.",
        "Everyone.",
      ],
      loop: true,
      showCursor: false,
      typeSpeed: 50,
    });
  }
  window.addEventListener("DOMContentLoaded", init);
})();
